import React, { useEffect, useState } from 'react'
import { mergeClasses } from '@/helpers/styling'
import { useFormFieldId } from './form'

export function Select(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  const defaultId = useFormFieldId()
  return (
    <select
      id={defaultId}
      {...props}
      className={mergeClasses(`
        w-full
        !px-[12px] h-8 rounded-md text-[13px]
        bg-white0 border border-border
        focus:ring-2 focus:ring-[#51479e]/40
        focus-visible:ring-2 focus-visible:ring-[#51479e]/40
      `, props.className)}>
      {props.children}
    </select>
  )
}

// A bit crude, but we seem to have nothing better (yet)
// and HTML input with datalist sucks
export function AddableSelect(props: Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "value" | "onChange" | "options"> & {
  value: string
  onChange: (value: string) => void
  specialCustomValue?: string
}) {
  const {
    value,
    onChange,
    specialCustomValue = "___CUSTOM___",
    ...selectProps } = props
  const allValues = collectOptionValues(props.children)
  const isCustomOption = props.value && !allValues.has(value)

  return (
    <Select {...selectProps}
            value={value}
            onChange={e => {
              if (e.currentTarget.value === specialCustomValue) {
                const value = window.prompt("Enter custom value")
                if (!value) return
                onChange(value)
              } else {
                onChange(e.currentTarget.value)
              }
            }}>
      {props.children}
      <optgroup label="Custom">
        {isCustomOption && <option value={value}>{value}</option>}
        <option value={specialCustomValue}>Custom...</option>
      </optgroup>
    </Select>
  )
}

function collectOptionValues(children: React.ReactNode): Set<string> {
  const values = new Set<string>()
  React.Children.forEach(children, elem => {
    if (!React.isValidElement(elem)) return
    if (elem.type === "option") {
      const value = elem.props.value
      const child = elem.props.children
      if (typeof value === "string") {
        // for <option value="value">label</option>
        values.add(value)
      } else if (typeof child === "string") {
        // for <option>value</option>
        values.add(child)
      }
      return
    }
    if (elem.type === "optgroup") {
      const nested = collectOptionValues(elem.props.children)
      nested.forEach(v => values.add(v))
      return
    }
    if (elem.props?.children) {
      const nested = collectOptionValues(elem.props.children)
      nested.forEach(v => values.add(v))
    }
  })
  return values
}
